import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { DEFAULT_DOMAIN } from '../../../constants/admin';
import styles from './styles.scss';

const propTypes = {
  hostnames: PropTypes.shape({
    fqdn: PropTypes.string.isRequired,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        ssl: PropTypes.bool,
      }),
    ),
  }).isRequired,
  page: PropTypes.shape({
    path: PropTypes.string.isRequired,
  }).isRequired,
};

const defaultProps = {
};

const getProtocol = items => (items && items.length && items[0].ssl
  ? 'https://'
  : 'http://');

const URLDisplay = ({ hostnames: { fqdn: domain, items }, page }) => (
  <div className={styles.url}>
    {domain || `${getProtocol(items)}${DEFAULT_DOMAIN}`}{page.path}
  </div>
);

URLDisplay.propTypes = propTypes;
URLDisplay.defaultProps = defaultProps;

URLDisplay.fragments = {
  page: gql`
    fragment urlDisplayPage on Page {
      path
    }
  `,
};

export default URLDisplay;
